import apiClient from '../client';
import { ApiUrls } from '../ApiUrls';

export interface SubmitBugReportPayload {
  issueType: 'bug' | 'wrong_result' | 'performance' | 'ui' | 'other';
  description?: string | null;
  conversationId?: string | null;
  projectId?: string | null;
  pageUrl?: string | null;
  sourceType?: string | null;
  userAgent?: string | null;
}

export const bugReportService = {
  submitBugReport(payload: SubmitBugReportPayload) {
    return apiClient.post(ApiUrls.submitBugReport, payload);
  },
};

export default bugReportService;
